import { appendLeadingZeros } from 'utils/appendLeadingZeros';

const MAX_OPACITY = 255;

export const opacityToHexValue = (value: number): string => appendLeadingZeros(Math.round(MAX_OPACITY * value / 100).toString(16));
